import { showAlert } from 'actions/client';
import EditButton from 'components/Dashboard/Panels/MenuEditor/components/shared/EditButton';
import ConfirmationDialog from 'components/Utility/Dialogs/ConfirmationDialog';
import StandardAccordion from 'components/Utility/StandardAccordion';
import React from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import {
  CreateClientAPIRequest,
  DeleteClientAPIRequest,
  FetchAllClientsAPIRequest,
  FetchAllMenusAPIRequest,
  UpdateClientAPIRequest,
} from '../../../../utils/constants/network';
import { callAPI } from '../../../../utils/network';
import CenteredSpinner from '../../../Utility/CenteredSpinner';
import AddButton from '../MenuEditor/components/shared/AddButton';
import ClientForm from './ClientForm';
import './index.scss';

const NewClientContainer = styled.div`
  padding: 28px 30px 28px 30px;
  width: 100%;
  ${props =>
    props.noClients
      ? css`
          padding-top: 24px;
        `
      : undefined}
`;

class ClientsPanel extends React.Component {
  state = {
    showNewClientForm: false,
    menus: null,
    clients: null,
    fetchingMenus: false,
    fetchingClients: false,
    creatingClient: false,
    expandedIds: [],
    editingIds: [],
    updatingClients: [],
    showDeleteConfirmation: false,
    clientToDelete: null, // {id, name, index}
  };

  async fetchAllMenus() {
    this.setState({ fetchingMenus: true });

    try {
      const apiRequest = FetchAllMenusAPIRequest(
        {},
        '?include_draft=true&include_clients=true'
      );
      const allMenus = await callAPI(apiRequest);

      this.setState({ menus: allMenus });
    } catch (e) {
      console.error(e);
      this.props.showAlert('Failure', 'Sorry, we could not fetch your menus.');
    } finally {
      this.setState({ fetchingMenus: false });
    }
  }

  async fetchAllClients() {
    this.setState({ fetchingClients: true });

    try {
      const apiRequest = FetchAllClientsAPIRequest({});
      const allClients = await callAPI(apiRequest);

      this.setState({ clients: allClients });
    } catch (e) {
      console.error(e);
      this.props.showAlert(
        'Failure',
        'Sorry, we could not fetch your clients.'
      );
    } finally {
      this.setState({ fetchingClients: false });
    }
  }

  async createNewClient(data) {
    this.setState({ creatingClient: true });

    try {
      const apiRequest = CreateClientAPIRequest(data);
      const newClient = await callAPI(apiRequest);

      const newIds = [...this.state.expandedIds, newClient._id];

      this.props.showAlert(
        'Success',
        `${newClient.name} has been successfully created.`
      );
      this.setState({
        clients: [...this.state.clients, newClient],
        expandedIds: newIds,
      });
    } catch (e) {
      console.error(e);
      this.props.showAlert(
        'Failure',
        'Sorry, we could not create a new Client.'
      );
    } finally {
      this.setState({ creatingClient: false, showNewClientForm: false });
    }
  }

  async updateClient(id, data, index) {
    const { updatingClients } = this.state;
    const updatingIndex = updatingClients.indexOf(id);
    let updatingIds = [...updatingClients];

    if (updatingIndex === -1) {
      updatingIds.push(id);
    }

    this.setState({ creatingClient: true, updatingClients: updatingIds });

    try {
      const apiRequest = UpdateClientAPIRequest({ id: id, changes: data });
      const newClient = await callAPI(apiRequest);

      const newClients = [...this.state.clients];
      newClients[index] = newClient;

      this.cancelEditing(id);

      this.props.showAlert(
        'Success',
        `${newClient.name} has been successfully updated.`
      );
      this.setState({ clients: newClients });
    } catch (e) {
      console.error(e);
      this.props.showAlert(
        'Failure',
        'Sorry, we could not update this client.'
      );
    } finally {
      const newIndex = updatingClients.indexOf(id);
      let newUpdatingIds = [...updatingClients];

      newUpdatingIds.splice(newIndex, 1);
      this.setState({ creatingClient: false, updatingClients: newUpdatingIds });
    }
  }

  async deleteClient(id, index, name) {
    const { updatingClients } = this.state;
    const updatingIndex = updatingClients.indexOf(id);

    let updatingIds = [...updatingClients];

    if (updatingIndex === -1) {
      updatingIds.push(id);
    }

    this.setState({ updatingClients: updatingIds });

    try {
      const apiRequest = DeleteClientAPIRequest({ id: id });
      await callAPI(apiRequest);

      const newClients = [...this.state.clients];
      newClients.splice(index, 1);

      this.collapseClient(id);
      this.cancelEditing(id);

      this.props.showAlert('Success', `${name} has been successfully removed.`);
      this.setState({ clients: newClients });
    } catch (e) {
      console.error(e);
      this.props.showAlert(
        'Failure',
        'Sorry, we could not delete this client.'
      );
    } finally {
      const newIndex = updatingClients.indexOf(id);
      let newUpdatingIds = [...updatingClients];

      newUpdatingIds.splice(newIndex, 1);
      this.setState({ updatingClients: newUpdatingIds });
    }
  }

  collapseClient(id) {
    const { expandedIds } = this.state;
    const expandedIndex = expandedIds.indexOf(id);

    if (expandedIndex !== -1) {
      let newIds = [...expandedIds];
      newIds.splice(expandedIndex, 1);

      this.setState({ expandedIds: newIds });
    }
  }

  cancelEditing(id) {
    const { editingIds } = this.state;
    const editingIndex = editingIds.indexOf(id);

    if (editingIndex !== -1) {
      let newIds = [...editingIds];
      newIds.splice(editingIndex, 1);

      this.setState({ editingIds: newIds });
    }
  }

  componentWillMount() {
    this.fetchAllMenus();
    this.fetchAllClients();
  }

  render() {
    const {
      showNewClientForm,
      fetchingMenus,
      fetchingClients,
      creatingClient,
      menus,
      clients,
      expandedIds,
      editingIds,
      updatingClients,
      showDeleteConfirmation,
      clientToDelete,
    } = this.state;
    const { venue } = this.props;

    const loading = fetchingMenus || fetchingClients;

    const addNewClient = () => {
      this.setState({ showNewClientForm: true });
    };

    const handleAccordionChange = (id, expanded) => {
      let newIds = [...expandedIds];
      const index = newIds.indexOf(id);

      if (index !== -1) {
        newIds.splice(index, 1);
      } else {
        newIds.push(id);
      }

      this.setState({ expandedIds: newIds });
    };

    const editClient = id => {
      const expandedIndex = expandedIds.indexOf(id);
      const editingIndex = editingIds.indexOf(id);

      if (expandedIndex === -1) {
        this.setState({ expandedIds: [...expandedIds, id] });
      }

      if (editingIndex === -1) {
        this.setState({ editingIds: [...editingIds, id] });
      }
    };

    return (
      <React.Fragment>
        <div className="panel__content">
          <div className="top__bar">
            <div className="title__row">
              <h2 className="panel__title">Clients</h2>
              <span className="beta__tag">BETA</span>
            </div>
          </div>

          <div
            className="panel__container tabb__shadow"
            style={{ padding: 0, gap: 0 }}
          >
            {loading && <CenteredSpinner />}

            {!loading && (
              <React.Fragment>
                {clients
                  ? clients.map((cData, index) => {
                      const isExpanded = expandedIds.indexOf(cData._id) !== -1;
                      const isEditing = editingIds.indexOf(cData._id) !== -1;
                      const isLoading =
                        updatingClients.indexOf(cData._id) !== -1;

                      return (
                        <StandardAccordion
                          key={cData._id}
                          renderActions={() =>
                            !isEditing ? (
                              <EditButton
                                onClick={e => {
                                  e.stopPropagation();
                                  editClient(cData._id);
                                }}
                              />
                            ) : null
                          }
                          title={cData.name}
                          isExpanded={isExpanded}
                          id={cData._id}
                          onChange={handleAccordionChange}
                        >
                          <ClientForm
                            loading={isLoading}
                            editing={isEditing}
                            onDelete={() => {
                              this.setState({
                                clientToDelete: {
                                  id: cData._id,
                                  index,
                                  name: cData.name,
                                },
                                showDeleteConfirmation: true,
                              });
                            }}
                            onSave={data =>
                              this.updateClient(cData._id, data, index)
                            }
                            onCancel={() => this.cancelEditing(cData._id)}
                            client={cData}
                            menus={menus}
                            venueSlug={venue.url_slug}
                          />
                        </StandardAccordion>
                      );
                    })
                  : null}

                <NewClientContainer
                  noClients={!clients || clients.length === 0}
                >
                  {loading && <CenteredSpinner />}

                  {!loading && (
                    <React.Fragment>
                      {showNewClientForm ? (
                        <div style={{ width: '100%' }}>
                          <ClientForm
                            loading={creatingClient}
                            onSave={data => this.createNewClient(data)}
                            onCancel={() =>
                              this.setState({ showNewClientForm: false })
                            }
                            menus={menus}
                            venueSlug={venue.url_slug}
                          />
                        </div>
                      ) : (
                        <AddButton onClick={() => addNewClient()}>
                          Add a Client
                        </AddButton>
                      )}
                    </React.Fragment>
                  )}
                </NewClientContainer>
              </React.Fragment>
            )}
          </div>
        </div>
        <ConfirmationDialog
          open={showDeleteConfirmation}
          confirmationTitle="Confirm you want to delete this client"
          onClose={() =>
            this.setState({
              clientToDelete: null,
              showDeleteConfirmation: false,
            })
          }
          showInput={false}
          variant="yesNo"
          positiveActionText="Yes, delete"
          negativeActionText="No, cancel"
          onConfirm={() => {
            const { id, index, name } = clientToDelete;
            this.setState(
              { clientToDelete: null, showDeleteConfirmation: false },
              () => {
                this.deleteClient(id, index, name);
              }
            );
          }}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  venue: state.venue,
});

const mapDispatchToProps = dispatch => ({
  showAlert: (title, desc) => dispatch(showAlert(title, desc)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientsPanel);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Client/index.jsx